/**
 * @generated SignedSource<<86b8e786be6d68dd6d0e0e9eb5307d99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateAssignmentInput = {
  assignmentId: string;
  dueOn: any;
  name: string;
  startedOn: any;
};
export type AssignmentUpdateMutation$variables = {
  input: UpdateAssignmentInput;
};
export type AssignmentUpdateMutation$data = {
  readonly updateAssignment: {
    readonly assignmentNode: {
      readonly id: string;
    } | null | undefined;
  };
};
export type AssignmentUpdateMutation = {
  response: AssignmentUpdateMutation$data;
  variables: AssignmentUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAssignmentPayload",
    "kind": "LinkedField",
    "name": "updateAssignment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AssignmentNode",
        "kind": "LinkedField",
        "name": "assignmentNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignmentUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "86564a405543b06f8b6023307e67b244",
    "id": null,
    "metadata": {},
    "name": "AssignmentUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AssignmentUpdateMutation(\n  $input: UpdateAssignmentInput!\n) {\n  updateAssignment(input: $input) {\n    assignmentNode {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e2abee0cd11a2fbfc412816ca3b1e218";

export default node;
